<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">消费统计<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <!--                <template #prefix>-->
                <!--                  <p class="select-itm">门店<span>|</span></p>-->
                <!--                </template>-->
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>


          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)">查询</ElButtons>
            </div>
<!--            <div class="content-input-btn">-->
<!--              <ElButtons icon="RefreshLeft" @click="refreshParam">重置</ElButtons>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
<!--        <div class="content-button">-->
<!--          <div>-->
<!--&lt;!&ndash;            <SearchUidOrPhone style="margin-right: 16px;" @confirm="openDialog($event)"/>&ndash;&gt;-->
<!--          </div>-->
<!--          <div style="display: flex; align-items: center;">-->
<!--            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>-->
<!--          </div>-->

<!--        </div>-->
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              @selection-change="selsChange"
              @header-click="selsAll"
              size="default"
              border
          >
<!--            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
            <el-table-column property="statDate" label="日期" v-if="checkColList.indexOf('日期') > -1"></el-table-column>
            <el-table-column property="week" label="星期" v-if="checkColList.indexOf('星期') > -1"/>
            <el-table-column property="shopName" label="门店" v-if="checkColList.indexOf('门店') > -1"></el-table-column>
            <el-table-column property="" label="预约单" v-if="checkColList.indexOf('预约单') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.preBookNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="普通单" v-if="checkColList.indexOf('普通单') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.generalNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="洗护只数" v-if="checkColList.indexOf('洗护只数') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.washingNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="零食已赠送" v-if="checkColList.indexOf('零食已赠送') > -1">
              <template #default="scope">
                <span>{{scope.row.snackNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="零食未赠送" v-if="checkColList.indexOf('零食未赠送') > -1">
              <template #default="scope">
                <span>{{scope.row.snackNoneNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="洗澡项目" v-if="checkColList.indexOf('洗澡项目') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.washingMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="增值服务" v-if="checkColList.indexOf('增值服务') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.incrementMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="物品销售" v-if="checkColList.indexOf('物品销售') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.goodSalesMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="猫咪接送" v-if="checkColList.indexOf('猫咪接送') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.pickUpNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="活体销售" v-if="checkColList.indexOf('活体销售') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.liveSalesMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="全身剃毛" v-if="checkColList.indexOf('全身剃毛') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.barberingMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="特殊服务" v-if="checkColList.indexOf('特殊服务') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.specialMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="定制套餐" v-if="checkColList.indexOf('定制套餐') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.customMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="寄养" v-if="checkColList.indexOf('寄养') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.fosterCareMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="其他" v-if="checkColList.indexOf('其他') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.otherMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="洁牙项目" v-if="checkColList.indexOf('洁牙项目') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.teethCleanMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="不计提成项目" v-if="checkColList.indexOf('不计提成项目') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.noCommissionMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="总金额" v-if="checkColList.indexOf('总金额') > -1">
              <template #default="scope">
                <span>{{scope.row.allMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="核销券" v-if="checkColList.indexOf('核销券') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.verifyTicketNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor">
              <template #default="scope">
                {{scope.row.remark}}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="sumDataList"
              style="width: 100%;"
              v-loading="listLoading"
              size="default"
              border
          >
            <el-table-column property="" label="汇总"></el-table-column>
            <el-table-column property="" label=""></el-table-column>
            <el-table-column property="" label=""></el-table-column>
            <el-table-column property="preBookNum" label="预约单"></el-table-column>
            <el-table-column property="generalNum" label="普通单"></el-table-column>
            <el-table-column property="washingNum" label="洗护只数"></el-table-column>
            <el-table-column property="snackNum" label="零食已赠送"></el-table-column>
            <el-table-column property="snackNoneNum" label="零食未赠送"></el-table-column>
            <el-table-column property="washingMoney" label="洗澡项目"></el-table-column>
            <el-table-column property="incrementMoney" label="增值服务"></el-table-column>
            <el-table-column property="goodSalesMoney" label="物品销售"></el-table-column>
            <el-table-column property="pickUpNum" label="猫咪接送"></el-table-column>
            <el-table-column property="liveSalesMoney" label="活体销售"></el-table-column>
            <el-table-column property="barberingMoney" label="全身剃毛"></el-table-column>
            <el-table-column property="specialMoney" label="特殊服务"></el-table-column>
            <el-table-column property="customMoney" label="定制套餐"></el-table-column>
            <el-table-column property="fosterCareMoney" label="寄养"></el-table-column>
            <el-table-column property="otherMoney" label="其他"></el-table-column>
            <el-table-column property="teethCleanMoney" label="洁牙项目"></el-table-column>
            <el-table-column property="noCommissionMoney" label="不计提成项目"></el-table-column>
            <el-table-column property="statDate" label="总金额">
              <template #default="scope">
                <span>{{scope.row.allMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="verifyTicketNum" label="核销券"></el-table-column>
            <el-table-column property="" label=""></el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {getFormData, imgPostFormData, postFormData} from "@/api/api";
import {getConsumeStatPageList, getConsumeStatSummary} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import UserInfo from "@/components/User/userInfo";
import DatePickerRange from "@/components/DatePickerRange_noL";
import RecordList from "@/views/user/components/RecordList";
import SearchUidOrPhone from "@/components/SearchUidOrPhone";
import SearchInfoDialog from "@/views/user/components/SearchInfoDialog";
import { decimal_NUM, add } from "@/assets/shared/util";
import remarkDialog from "@/views/stat/components/ComsumeRemarkDialog";
import consumeNumDialog from "@/views/stat/components/consumeNumDialog";
import ProjectShopDialog from "@/views/stat/components/ProjectShopDialog";
import unLock from "@/layout/components/unLock";
import BonusNumDialog from "@/views/stat/components/BonusNumDialog";

export default {
  name: "StatConsume",
  components: {BtnGroup, SearchComponents, SearchUidOrPhone, UserInfo, DatePickerRange, RecordList, unLock },
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
        {label: '未知', value: 0}
      ],
      sex: -1,


      //刷新组
      colList: ['日期', '星期', '门店', '预约单', '普通单', '洗护只数', '零食已赠送', '零食未赠送', '洗澡项目', '增值服务', '物品销售', '猫咪接送', '活体销售', '全身剃毛', '特殊服务', '定制套餐', '寄养', '其他', '洁牙项目', '不计提成项目',  '总金额', '核销券', '备注'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '称呼', value : 2},
      ],
      searchType: 1,
      searchValue: '',

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //抵扣时间
      startDeductionTime: '',
      endDeductionTime: '',
      isDeductionChecked: true,

      idArray: [],
      sort: 2,

      upChargeLoading: false,


    }
  },
  methods: {

    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.isDeductionChecked = true;
      this.sex = -1;
      this.shopId = 0;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getConsumeStatPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          this.pageDataList.map(item => {
            item.allMoney = add([item.washingMoney, item.incrementMoney, item.goodSalesMoney, item.liveSalesMoney, item.otherMoney])
          })
          this.getSumPage(param)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    getSumPage(param) {
      getFormData(getConsumeStatSummary, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          this.sumDataList = []
          let result = data['data'];
          result.allMoney = add([result.washingMoney, result.incrementMoney, result.goodSalesMoney, result.liveSalesMoney, result.otherMoney])
          this.sumDataList.push(result)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
          .catch((response) => {
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },


    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }


      if(column.label == '备注') {
        let remarkForm = Object.assign({}, row);
        Dialog.open({
          title: '更新备注',
          component: remarkDialog,
          data: {
            remarkForm: remarkForm,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '预约单' || column.label == '普通单') {
        let consumeForm = Object.assign({}, row);
        let type = column.label == '预约单'?1:2
        Dialog.open({
          title: column.label,
          component: consumeNumDialog,
          data: {
            consumeForm: consumeForm,
            type: type,
            serviceType: 0,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '洗护只数') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '洗护只数',
          component: consumeNumDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 1,
            type: 0,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '洗澡项目') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '洗澡项目',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 1,
            projectType: 0,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '增值服务') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '增值服务',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 2,
            projectType: 0,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '物品销售') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '物品销售',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 3,
            projectType: 0,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '猫咪接送') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '猫咪接送',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 6,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '活体销售') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '活体销售',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 4,
            projectType: 0,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '全身剃毛') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '全身剃毛',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 9,
            projectType: 0,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '定制套餐') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '定制套餐',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 7,
            projectType: 0,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }
      if(column.label == '特殊服务') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '特殊服务',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 10,
            projectType: 0,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '寄养') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '寄养',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 8,
            projectType: 0,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '其他') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '其他',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 5,
            projectType: 0,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '洁牙项目') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '洁牙项目',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 11,
            projectType: 0,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '不计提成项目') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '不计提成项目',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 12,
            projectType: 0,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '核销券') {
        let consumeForm = Object.assign({}, row);
        Dialog.open({
          title: '核销券',
          component: ProjectShopDialog,
          data: {
            consumeForm: consumeForm,
            serviceType: 1,
            projectType: 2,
            width: '600px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }


    },


    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        title: '',
        component: SearchInfoDialog,
        data: {
          userForm: e,
          width: '700px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
